var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject } from "aurelia-dependency-injection";
import { BaseWidget } from "./base-widget";
import { transient } from "aurelia-dependency-injection";
import { DataType, SourceType, ProjectionPropertyOrdering } from "../models/queries/queries.models";
import { Router } from "aurelia-router";
import { EntityTypeConfigurationHelper } from "../models/basics/basics.models";
import { computedFrom } from "aurelia-binding";
import { SignalClientService } from "../services/basics/signal-client.service";
import * as Enumerable from "linq";
import moment from "moment";
import { QueriesClientService } from "../services/queries/queries-client.services";
var ListWidget = /** @class */ (function (_super) {
    __extends(ListWidget, _super);
    function ListWidget(router, queriesService, entityTypeConfigurationHelper, signalClientService) {
        var _this = _super.call(this, signalClientService) || this;
        _this.router = router;
        _this.queriesService = queriesService;
        _this.entityTypeConfigurationHelper = entityTypeConfigurationHelper;
        _this.entityTypes = _this.entityTypeConfigurationHelper.getConfiguration([]);
        return _this;
    }
    Object.defineProperty(ListWidget.prototype, "dataGrid", {
        get: function () {
            return this._dataGrid;
        },
        set: function (value) {
            this._dataGrid = value;
            this.attachDataGrid();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ListWidget.prototype, "type", {
        get: function () {
            if (!this.entityType) {
                return null;
            }
            if (typeof this.entityType.navbar == "boolean") {
                return this.entityType.uri.replace(/\s/g, "").toLowerCase();
            }
            return this.entityType.navbar.replace(/\s/g, "").toLowerCase();
        },
        enumerable: false,
        configurable: true
    });
    ListWidget.prototype.onActivate = function (model) {
        var _this = this;
        this.title = model.title;
        this.model = model;
        this.entityType = this.entityTypes.filter(function (x) { return x.uri && x.uri.replace(/\s/g, "") === _this.model.entityTypeUri.replace(/\s/g, ""); })[0];
        this.queriesService.getEntityModels().then(function (x) {
            var e_1, _a;
            var entityModel = Enumerable.from(x).first(function (a) { return a.uri && a.uri == model.entityTypeUri; });
            var _loop_1 = function (column) {
                var projectedProperty = entityModel.projectionProperties.filter(function (x) { return x.name == column.name; })[0];
                if (column.isAscending == null && projectedProperty && projectedProperty.defaultOrdering == ProjectionPropertyOrdering.Ascending) {
                    column.isAscending = true;
                    column.isSortable = true;
                }
                if (column.isAscending == null && projectedProperty && projectedProperty.defaultOrdering == ProjectionPropertyOrdering.Descending) {
                    column.isAscending = false;
                    column.isSortable = true;
                }
                if (column.dataType == DataType.Date || column.dataType == DataType.DateTime) {
                    column.valueConverter = function (value) {
                        if (!value || !projectedProperty) {
                            return "";
                        }
                        if (projectedProperty.type == DataType.DateTime) {
                            return moment(value).format(projectedProperty.format);
                        }
                        else {
                            return moment.utc(value).format(projectedProperty.format);
                        }
                    };
                }
                if (_this.entityType && _this.entityType.converters) {
                    var converter_1 = _this.entityType.converters.filter(function (x) { return x.property == column.name; })[0];
                    if (converter_1) {
                        column.valueConverter = function (value, item) { return converter_1.func(value, item, null); };
                    }
                }
            };
            try {
                for (var _b = __values(model.columns), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var column = _c.value;
                    _loop_1(column);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            _this.attachDataGrid();
            if (model.entityTypeUri) {
                var uri = "odata/" + model.entityTypeUri;
                var columns = [];
                if (_this.entityType && _this.entityType.fixedColumns)
                    columns = columns.concat(_this.entityType.fixedColumns);
                columns = Enumerable.from(columns).concat(model.columns).toArray();
                _this.itemSource = {
                    source: uri,
                    sourceType: SourceType.ODataUrl,
                    columns: columns,
                    initialFilters: model.queryFilters,
                    limit: model.limit,
                    propertyDefaults: _this.entityType ? _this.entityType.gridConfig : null
                };
            }
        });
    };
    ListWidget.prototype.doubleClick = function (event) {
        this.selectedItem = event.detail.item;
        var editRoute = this.entityType ? this.entityType.editRoute : this.model.editRoute;
        if (typeof editRoute === "function") {
            editRoute({ id: this.selectedItem.id, item: this.selectedItem }, this.router);
        }
        else {
            this.router.navigateToRoute(editRoute, { id: this.selectedItem.id });
        }
    };
    ListWidget.prototype.onItemSelected = function (event) {
        this.selectedItem = event.detail.item;
    };
    ListWidget.prototype.attachDataGrid = function () {
        if (this.dataGrid) {
            this.dataGrid.attached();
        }
    };
    __decorate([
        computedFrom('entityType'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], ListWidget.prototype, "type", null);
    ListWidget = __decorate([
        transient(),
        autoinject(),
        __metadata("design:paramtypes", [Router, QueriesClientService,
            EntityTypeConfigurationHelper,
            SignalClientService])
    ], ListWidget);
    return ListWidget;
}(BaseWidget));
export { ListWidget };
